import { isAdmin } from '@core/util/util.isEditor';
import { getRoleOverride } from '@frontend/components/RoleSelector';
import {
  useDirectoryMe,
  useDirectoryTeam,
} from '@frontend/shared/hooks/useDirectory';

export function useIsAdmin() {
  const me = useDirectoryMe();
  const team = useDirectoryTeam();

  // Check for dev role override
  const roleOverride = getRoleOverride();
  if (roleOverride === 'admin') return true;
  if (roleOverride === 'editor' || roleOverride === 'viewer') return false;

  return isAdmin(team, me.id);
}
